module.exports = __webpack_public_path__ + "MaterialIcons-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.ttf
// module id = 81
// module chunks = 0